"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stackTheDeck = exports.andDeckWillDeal = exports.andPlayerXHasCardsY = exports.andAHandIsDealt = exports.givenXplayersAtATableWithBuyInOfYChips = exports.givenXplayersAtATable = void 0;
const givenXplayersAtATable = (given, table) => {
    given(/^(\d+) players at a table$/, (playerCountStr) => {
        const playerCount = parseInt(playerCountStr, 10);
        addPlayersToTableWithBuyIn(playerCount, 10000, table);
    });
};
exports.givenXplayersAtATable = givenXplayersAtATable;
const givenXplayersAtATableWithBuyInOfYChips = (given, table) => {
    given(/^(\d+) players at a table with buy in of (\d+) chips$/, (playerCountStr, chips) => {
        const playerCount = parseInt(playerCountStr, 10);
        const chipBuyIn = parseInt(chips, 10);
        addPlayersToTableWithBuyIn(playerCount, chipBuyIn, table);
    });
};
exports.givenXplayersAtATableWithBuyInOfYChips = givenXplayersAtATableWithBuyInOfYChips;
const addPlayersToTableWithBuyIn = (playerCount, buyInChips, table) => {
    for (let i = playerCount - 1; i >= 0; i--) {
        table.addPlayer(`player_${i}`, buyInChips, `${i}`);
    }
};
const andAHandIsDealt = (and, table) => {
    and('a hand is dealt', () => {
        table.newHand();
    });
};
exports.andAHandIsDealt = andAHandIsDealt;
const andPlayerXHasCardsY = (and, table) => {
    and(/^(.*) has (.*) and (.*)$/, (playerName, cardOne, cardTwo) => {
        const player = table.getPlayerByName(playerName);
        player.returnCards();
        player.getCards([cardOne, cardTwo]);
        removeCardsFromDeck(table, [cardOne, cardTwo]);
    });
};
exports.andPlayerXHasCardsY = andPlayerXHasCardsY;
const andDeckWillDeal = (and, table) => {
    and(/^deck will deal (.*), (.*), (.*), (.*), (.*), (.*), (.*), (.*), (.*), (.*)$/, (...cards) => {
        stackTheDeck(table, cards);
    });
};
exports.andDeckWillDeal = andDeckWillDeal;
const stackTheDeck = (table, cards) => {
    removeCardsFromDeck(table, cards);
    cards.map((card) => {
        if (card) {
            table.board.deck.cards.unshift(card);
        }
    });
};
exports.stackTheDeck = stackTheDeck;
const removeCardsFromDeck = (table, cards) => {
    cards.map((card) => {
        if (table.board.deck.cards.includes(card)) {
            let idx = table.board.deck.cards.indexOf(card);
            table.board.deck.cards.splice(idx, 1);
        }
    });
};
//# sourceMappingURL=common.steps.js.map